// extracted by mini-css-extract-plugin
export var carrierIcon = "_w2-0";
export var carrierLogo = "_w2-1";
export var detailsSection = "_w2-2";